<template>
  <v-form @submit.prevent="search">
    <v-text-field
      :color="baseColor"
      label="search"
      append-icon="search"
      v-model="query"
    ></v-text-field>
  </v-form>
</template>
<script>
  export default {
    name: 'SearchForm',
    data () {
      return {
        query: null,
        baseColor: this.$store.state.baseColor
      }
    },
    methods: {
      /**
       * Redirect to the search results page and pass the query parameter
       * @method search
       * @return void
       * **/
      search () {
        const query = this.query
        if (!query) {
          return
        }
        this.$router.push({
          path: `/search/1/${this.query}`
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/SearchForm.vue